import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email required'),
});

export default validationSchema;
